import script from "./QuantityEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./QuantityEditor.vue?vue&type=script&lang=ts&setup=true"

import "./QuantityEditor.vue?vue&type=style&index=0&id=072b6995&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-072b6995"]])

export default __exports__